export abstract class Validators {

    // Returns if a value is a string
    static isString(value: any) {
        return typeof value === 'string' || value instanceof String;
    }

    // Returns if a value is really a number
    static isNumber(value: any) {
        return typeof value === 'number' && isFinite(value);
    }

    // Returns if a value is an array
    static isArray(value: any) {
        return value && typeof value === 'object' && value.constructor === Array;
    }

    // Returns if a value is a function
    static isFunction(value: any) {
        return typeof value === 'function';
    }

    // Returns if a value is an object
    static isObject(value: any) {
        return value && typeof value === 'object' && value.constructor === Object;
    }

    // Returns if a value is null
    static isNull(value: any) {
        return value === null;
    }

    // Returns if a value is undefined
    static isUndefined(value: any) {
        return typeof value === 'undefined';
    }

    static isNullOrUndefined(value: any) {
        return Validators.isNull(value) || Validators.isUndefined(value);
    }

    // Returns if a value is a boolean
    static isBoolean(value: any) {
        return typeof value === 'boolean';
    }

    // Returns if a value is a regexp
    static isRegExp(value: any) {
        return value && typeof value === 'object' && value.constructor === RegExp;
    }

    // Returns if value is an error object
    static isError(value: any) {
        return value instanceof Error && typeof value.message !== 'undefined';
    }

    // Returns if value is a date object
    static isDate(value: any) {
        return value instanceof Date;
    }

    // Returns if a Symbol
    static isSymbol(value: any) {
        return typeof value === 'symbol';
    }


    isValidEmail(email: string) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email)
    }
}


// WEBPACK FOOTER //
// ../inline/src/modules/shared/validators.ts